import styled, { css } from "styled-components";
import { Theme, breakpoints } from "@tvg/design-system";

const getContainerBackgroundColor = (
  theme: Theme,
  isPickHeader: boolean,
  isRacecardScrollable: boolean
) => {
  if (isRacecardScrollable) {
    return theme.colorTokens.background.layer;
  }

  return isPickHeader ? "transparent" : theme.colorTokens.background.surface;
};

export const CurrentRaceContainer = styled.div<{
  isPickHeader?: boolean;
  isRacecardScrollable?: boolean;
}>`
  width: 100%;
  height: 100%;
  display: flex;
  padding: ${({ theme }) => theme.space["space-4"]};
  background-color: ${({ theme, isPickHeader, isRacecardScrollable }) =>
    getContainerBackgroundColor(theme, !!isPickHeader, !!isRacecardScrollable)};
  ${({ theme, isRacecardScrollable }) =>
    isRacecardScrollable &&
    css`
      border-bottom: 1px solid ${theme.colorTokens.border.default};
    `};

  /* stylelint-disable-next-line media-query-no-invalid */
  @media screen and ${breakpoints.tablet.max.sm} {
    border-bottom: 0;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colorTokens.background.surface};
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RaceDetailsContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 2px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  /* stylelint-disable-next-line media-query-no-invalid */
  @media screen and ${breakpoints.tablet.max.sm} {
    row-gap: 2px;
  }
`;

export const ButtonsContainer = styled.div<{ hidden: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  row-gap: ${({ theme }) => theme.space["space-1"]};

  &:is(:empty) {
    display: none;
  }

  /* stylelint-disable-next-line media-query-no-invalid */
  @media screen and ${breakpoints.tablet.max.sm} {
    flex-direction: row;
    align-items: flex-start;
    margin-top: ${({ theme }) => theme.space["space-4"]};
    width: 100%;
    ${({ hidden }) =>
      hidden &&
      css`
        display: none;
      `}
  }

  /* stylelint-disable-next-line media-query-no-invalid */
  @media screen and ${breakpoints.desktop.min.sm} {
    flex-shrink: 0;
  }
`;

export const ActiveBetsButtonContainer = styled.div`
  display: flex;
`;
